import { useQuery } from '@tanstack/react-query'
import { QueryKey } from 'src/reactQuery/enums/queryKey.enum'
import { ReviewAnalysisApiService } from 'src/services/reviewAnalysisApi'

interface UseGetReviewAnalysisCampaignsQueryParams {
  enabled?: boolean
}

export const useGetReviewAnalysisCampaignsQuery = ({
  enabled = true,
}: UseGetReviewAnalysisCampaignsQueryParams = {}) =>
  useQuery({
    enabled,
    queryFn: () => ReviewAnalysisApiService.getCampaigns(),
    queryKey: [QueryKey.GET_REVIEW_ANALYSIS_CAMPAIGNS],
  })
